import {
  GET_HOME_HUB_REQUEST,
  GET_HOME_HUB_SUCCESS,
} from '../constants/actionTypes';

export const getHubHomeRequest = (payload) => ({
  type: GET_HOME_HUB_REQUEST,
  payload,
});

export const getHubHomeSuccess = (payload) => ({
  type: GET_HOME_HUB_SUCCESS,
  payload,
});
